import { Battery, BioGas, Sun, Water, WindPowerPlant } from "@/components/Icons";
import SourceButton from "@/components/SourceButton";
import Text from "@/components/Text";
import classes from "./GreenSource.module.css";
import { useTranslation } from "@/i18n/client";

interface GreenSourceProps {
  value?: string | null;
  withHeader?: boolean;
  onChange: (value: string) => void;
}

export const GreenSource = ({ value, withHeader, onChange }: GreenSourceProps) => {
  const { t } = useTranslation("modals");
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        {withHeader && <Text variant="h4">{t("tariffChange.greenSource")}</Text>}
        <Text variant="reading_medium">{t("tariffChange.greenSourceMessage")}</Text>
      </div>
      <div className={classes.sources}>
        <div className={classes.source}>
          <SourceButton active={value === "S"} onClick={() => onChange("S")}>
            <Sun />
          </SourceButton>
          <Text variant={value === "S" ? "reading_small_bold" : "reading_small"}>{t("tariffChange.greenSourceSun")}</Text>
        </div>
        <div className={classes.source}>
          <SourceButton active={value === "V"} onClick={() => onChange("V")}>
            <Water />
          </SourceButton>
          <Text variant={value === "V" ? "reading_small_bold" : "reading_small"}>{t("tariffChange.greenSourceWater")}</Text>
        </div>
        <div className={classes.source}>
          <SourceButton active={value === "W"} onClick={() => onChange("W")}>
            <WindPowerPlant />
          </SourceButton>
          <Text variant={value === "W" ? "reading_small_bold" : "reading_small"}>{t("tariffChange.greenSourceWind")}</Text>
        </div>
        <div className={classes.source}>
          <SourceButton active={value === "B"} onClick={() => onChange("B")}>
            <BioGas />
          </SourceButton>
          <Text variant={value === "B" ? "reading_small_bold" : "reading_small"}>{t("tariffChange.greenSourceBioGas")}</Text>
        </div>
        <div className={classes.source}>
          <SourceButton active={value === "M"} onClick={() => onChange("M")}>
            <Battery />
          </SourceButton>
          <Text variant={value === "M" ? "reading_small_bold" : "reading_small"}>{t("tariffChange.greenSourceAny")}</Text>
        </div>
      </div>
    </div>
  );
};
